var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileProcessed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Processed"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 610",
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 6,
    fill: "#04B761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M9 17.1666L14.6667 22.8332L26.0001 11.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileProcessed);
export default __webpack_public_path__ + "static/media/file-processed.01b73f1512332ffb3ad73fbf152227e9.svg";
export { ForwardRef as ReactComponent };